import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import FrictionWall from "./pages/FrictionWall";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background font-mono text-sm text-muted-foreground">
        <span className="w-2 h-2 bg-primary live-dot mr-2" /> Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppInner() {
  const location = useLocation();
  // Handle OAuth return BEFORE any route/auth logic to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/live" element={<FrictionWall />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="light" richColors />
          <AppInner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
